<template>
  <v-row justify="center">
    <v-col cols="12" lg="10" md="10" sm="12" xs="12">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>History of Changes</v-toolbar-title>
        </v-toolbar>
        <div v-if="paper.changeLogs == undefined" class="pa-4 grey--text">
          No changes to show
        </div>
        <v-card-text class="py-0" v-else>
          <v-timeline dense>
            <v-slide-x-reverse-transition group hide-on-leave>
              <v-timeline-item
                v-for="(log, i) in orderedChangeLogs"
                :key="i"
                small
                fill-dot
              >
                <v-alert :value="true">
                  <v-row>
                      <div style="font-weight:bold">{{log.datetime}}</div>
                      <div class="px-4">-</div>
                      <div>{{log.label}}</div>
                  </v-row>
                </v-alert>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["paper"],
  data() {
    return {};
  },
  computed: {
      orderedChangeLogs(){
          return this.orderChangeLogs()
      }
  },
  methods: {
    orderChangeLogs() {
      let array = Object.assign([], this.paper.changeLogs.reverse());
      return array;
    },
  },
};
</script>